export default __webpack_public_path__ + "static/media/orderByFileExample.301e71ae.jpg";